module.exports = __webpack_public_path__ + "static/media/11.94bb433f.png";